import styled from "styled-components";

export const Styled = styled.div`
  text-align: left;
  select {
    width: 100px;
    padding: 10px;
    background-color: #5cb85c;
    color: white;
    border: 1px solid #4cae4c;
    border-radius: 5px;
    font-weight: bold;
  }
  option {
    background-color: white;
    color: black;
  }
`;
